import Icon from '../components/Icon.vue'

Icon.register({
  'globe-asia': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM236.7 248.2l17.4-29c1.8-3 6.2-2.8 7.8 0.3 1.3 2.7 4.1 4.4 7.2 4.4h3.1c4.4 0 8-3.6 8-8v-78.1c0-6.1-3.4-11.6-8.8-14.3l-10.8-5.4c-5.5-2.8-6-10.4-0.9-13.8l50.2-38.5c-19.4-6.3-40.1-9.8-61.6-9.8-110.3 0-200 89.7-200 200 0 10.9 1.1 21.5 2.8 32h62.6c4.2 0 8.3-1.7 11.3-4.7l19.5-19.5c3.9-3.9 10.4-2.8 12.8 2.1l22.6 45.2c2.7 5.4 8.3 8.8 14.3 8.8h6.1c8.8 0 16-7.2 16-16v-9.4c0-4.2-1.7-8.3-4.7-11.3l-5.7-5.7c-3.1-3.1-3.1-8.2 0-11.3l5.7-5.7c3-3 7.1-4.7 11.3-4.7h0.3c5.6 0 10.8-3 13.7-7.8zM408 358.4l0-24.6c0-4.2-1.7-8.3-4.7-11.3l-11.9-11.9c-1.5-1.5-2.3-3.5-2.3-5.7v-12.9c0-2.2-1.8-4-4-4h-6.1c-1.8 0-3.3 1.2-3.8 2.9l-4.2 14.5c-0.5 1.7-2.1 2.9-3.8 2.9h-3.8c-1.5 0-3.1-1.1-3.7-2.5l-5.4-12.8c-1.2-3-4.2-4.9-7.4-4.9h-12.1 0c-1.4 0-3.5 0.7-4.6 1.5l-23.7 16.9c-1.7 1.2-3.6 2.3-5.6 3l-39.3 15.7c-3 1.2-5 4.2-5 7.4v10.2 0c0 1.8 1 4.4 2.3 5.7l11.9 11.9c3 3 7.1 4.7 11.3 4.7h10.3c1.3 0 2.6-0.2 3.9-0.5l21.3-5.3c1.8-0.4 4.7-0.8 6.5-0.8 6.1 0 14.6 3.5 18.9 7.8l13 13c3 3 7.1 4.7 11.3 4.7h15.2c4.2 0 8.3-1.7 11.3-4.7l9.6-9.6c3-3 4.7-7.1 4.7-11.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe-asia.js
// module id = 1393
// module chunks = 0